import { generateMeasuresFromDimensions } from './generate-measures.js';
import { departmentLink, legislativeItemLink, meetingBodyLink, userLink } from './links.js';
import { legislativeItemSystemStatusValueLabels } from './value-labels.js';
const aggregatableDimensions = {
    'legislative_workflow_pipeline.days_in_pipeline': {
        aggregations: ['avg'],
        label: 'Days In Pipeline',
        type: 'number',
    },
};
/**
 * Combination data source: Agenda Items x Item Workflows.
 * Legislative items with their internal approval workflow progress. Tracks which items are
 * stuck in approval, workflow bottlenecks, and average time from submission to agenda-ready.
 */
export const legislativeWorkflowPipelineCube = {
    category: 'Legislation',
    description: 'Legislative items with workflow approval progress, step tracking, and pipeline duration.',
    label: 'Legislative Workflow Pipeline',
    requiredModule: 'hasAgenda',
    measures: {
        'legislative_workflow_pipeline.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
        'legislative_workflow_pipeline.total_completed_steps_sum': {
            label: 'Total Completed Steps',
            type: 'number',
        },
        'legislative_workflow_pipeline.total_workflow_steps_sum': {
            label: 'Total Workflow Steps',
            type: 'number',
        },
    },
    dimensions: {
        ...aggregatableDimensions,
        // Legislative Item
        'legislative_items.code': { label: 'Item Number', link: legislativeItemLink, type: 'string' },
        'legislative_items.full_title': {
            label: 'Item Title',
            link: legislativeItemLink,
            type: 'string',
        },
        'legislative_items.status': {
            label: 'System Status',
            type: 'string',
            valueLabels: legislativeItemSystemStatusValueLabels,
        },
        // Status & Type
        'legislative_statuses.name': { label: 'Public Meeting Status', type: 'string' },
        'legislative_types.name': { label: 'Item Type', type: 'string' },
        // Workflow
        'legislative_workflow_pipeline.completed_workflow_steps': {
            label: 'Completed Steps',
            type: 'number',
        },
        'legislative_workflow_pipeline.current_workflow_step': {
            label: 'Current Step',
            type: 'string',
        },
        'legislative_workflow_pipeline.total_workflow_steps': {
            label: 'Total Steps',
            type: 'number',
        },
        'legislative_workflow_pipeline.workflow_name': { label: 'Workflow', type: 'string' },
        'legislative_workflow_pipeline.workflow_status': { label: 'Workflow Status', type: 'string' },
        // Context
        'departments.name': { label: 'Department', link: departmentLink, type: 'string' },
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
        'users.display_name': { label: 'Staff Contact', link: userLink, type: 'string' },
    },
    timeDimensions: {
        'legislative_items.created_at': { label: 'Item Created At', type: 'date' },
        'legislative_items.target_meeting_date': { label: 'Target Meeting Date', type: 'date' },
    },
};
